import { Link } from 'react-router';

/** Marca: un brote de cuatro hilos (las cuatro líneas de los abuelos). */
export function BrandMark({ size = 32 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden>
      <rect width="64" height="64" rx="16" fill="var(--pine)" />
      <path d="M32 52V30M32 30c0-8 8-12 14-12M32 30c0-8-8-12-14-12M32 40c0-5 6-8 10-8M32 40c0-5-6-8-10-8" stroke="var(--on-pine)" strokeWidth="3.5" fill="none" strokeLinecap="round" />
      <circle cx="46" cy="18" r="4" fill="var(--ochre)" />
      <circle cx="18" cy="18" r="4" fill="var(--cochineal)" />
      <circle cx="42" cy="32" r="3" fill="#7f9be0" />
      <circle cx="22" cy="32" r="3" fill="#86b47c" />
    </svg>
  );
}

export function Brand({ to = '/' }: { to?: string }) {
  return (
    <Link to={to} className="flex items-center gap-2.5 rounded-lg">
      <BrandMark />
      <span className="font-serif text-[19px] font-semibold tracking-tight">Gallarday</span>
    </Link>
  );
}
